import { render, staticRenderFns } from "./_algoliaSearch.vue?vue&type=template&id=ec94566e"
import script from "./_algoliaSearch.vue?vue&type=script&lang=js"
export * from "./_algoliaSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports